export default {
  app: {
    privacy: {
      policy: 'Política de privacidad',
      expansive: 'Al usar Expansive, aceptas la {action} de Expansive',
      client: '@:app.privacy.expansive{lineBreak}& {clientName} {clientAction}',
    },
    sessionExpired: 'Sesión expirada',
    sessionExpiredDescription:
      'Tu sesión ha expirado. Por favor, inicia sesión nuevamente para continuar usando la aplicación.',
  },
  components: {
    appContainer: {
      chooseLanguage: 'Elegir idioma',
      chooseLanguageDescription:
        'Elige tu idioma preferido para la aplicación. Esto cambiará el idioma de la interfaz y el contenido.',
    },
    userSelection: {
      cancel: 'Cancelar',
      createNewUser: 'Su nombre no está en la lista',
      newUser: 'Nuevo usuario',
      selectAnExistingUser: 'Seleccionar un usuario existente',
      selectUserHint: 'Selecciona un usuario existente o crea uno nuevo para continuar.',
      startTypingToSearch: 'Comienza a escribir...',
    },
    verification: {
      codeVerification: {
        continue: 'Continuar',
        header: 'Introduce el código de acceso al sitio',
        invalidCode: 'Código inválido, por favor intenta de nuevo.',
      },
      geoVerification: {
        continueWithoutVerifying: 'Continuar sin verificar ubicación',
        enterSiteAccessCode: 'Introduce el código de acceso al sitio',
        locationNotEnabledOrAvailable: '¿Por qué veo esto?',
        notAvailable: {
          description: 'La ubicación GPS no está soportada en este dispositivo.',
          header: 'Ubicación no soportada',
        },
        notEnabled: {
          description:
            'Los servicios de ubicación no están habilitados o no se ha concedido permiso.',
          header: 'Ubicación no habilitada',
        },
        notVerified: {
          description: 'El GPS indica que no estás en el sitio.',
          header: 'Ubicación no verificada',
        },
        tryAgain: 'Intentar de nuevo',
        unavailable: {
          description: 'No pudimos verificar tu ubicación GPS.',
          header: 'Ubicación no disponible',
        },
        unknown: {
          description: 'No podemos determinar tu ubicación.',
          header: 'Ubicación desconocida',
        },
        verified: {
          description: 'El GPS indica que estás en el sitio.',
          header: 'Ubicación verificada',
        },
      },
    },
    workOrder: {
      assets: {
        emptyTitle: 'No se encontraron activos',
        emptyDescription: 'No hay activos asociados a esta orden de trabajo.',
        warrantyParts: 'La garantía de las piezas expira',
        serialNumber: 'Número de serie',
        none: '<ninguno>',
      },
      updates: {
        emptyTitle: 'No se encontraron actualizaciones',
        emptyDescription: 'No hay actualizaciones para esta orden de trabajo.',
        unknownUser: 'Usuario desconocido',
        none: 'Ninguno',
        addComment: {
          buttonLabel: 'Agregar comentario',
        },
      },
      startWorkCheck: {
        startWorkCheckList: {
          hazards: 'Peligros',
          no: 'No',
          yes: 'Sí',
        },
      },
    },
    attachmentsList: {
      attachments: 'Adjuntos',
      documents: 'Documentos',
      siteDocuments: 'Documentos del sitio',
    },
  },
  stores: {
    authenticated: {
      startWorkCheckStore: {
        hazards: 'Peligros',
        induction: 'Inducción',
        safeToProceed: 'Seguro para proceder',
      },
    },
  },
  views: {
    authenticated: {
      sessions: {
        dueBy: 'Fecha de vencimiento',
        activeSessions: 'Sesiones activas',
        activeSessionsDescription:
          'Ya estás registrado en las siguientes órdenes de trabajo. Debes salir de estas órdenes antes de registrarte en una nueva.',
        resumeSession: 'Reanudar',
        startTime: 'Iniciado a las',
        unexpectedErrorTitle: 'Error inesperado',
        unexpectedErrorMessage:
          'Ocurrió un error inesperado al intentar crear tus sesiones. Por favor, inténtalo de nuevo más tarde.',
        engineerNotFound: 'Ingeniero no encontrado',
        engineerNotFoundDescription:
          'El ingeniero que intentas registrar no se encuentra en el sistema. Por favor, contacta a tu administrador.',
      },
      verification: {
        code: {
          description:
            'Para registrarte, por favor obtén el código de 4 dígitos del encargado del sitio o contacto designado.',
        },
        geo: {
          continue: 'Continuar',
        },
      },
      workOrders: {
        checkout: {
          index: {
            signOff:
              'Por favor, obtenga el código de acceso del gerente del sitio o del contacto designado para completar su visita.',
            checkOut: 'Salir',
            completeBeforeLeaving: 'Por favor, completa el siguiente formulario antes de salir.',
            continue: 'Continuar',
            noResolutionSelected: 'Por favor, selecciona una resolución antes de continuar.',
            quoteRequired: {
              hint: 'Visita completada, cotización pendiente',
              label: 'Cotización requerida',
            },
            returnVisitRequired: {
              hint: 'Regresaremos para completar',
              label: 'Visita de regreso requerida',
            },
            serviceCompleted: {
              hint: 'No se requiere más acción',
              label: 'Servicio completado',
            },
            uploadCheckout: 'Sube un archivo, foto o video',
            visitNotes: 'Notas de la visita',
            workOrderResolution: 'Resolución de la orden de trabajo',
            enterNotes: 'Ingresa cualquier nota aquí...',
            errors: {
              timedOut:
                'Tiempo de espera agotado, se excedieron los 30 segundos. Por favor, inténtalo de nuevo.',
              closingSession: 'Error al cerrar la sesión',
            },
          },
          success: {
            description:
              'Gracias por visitar {site}. | {site} aún tiene 1 orden de trabajo abierta. | {site} aún tiene {count} órdenes de trabajo abiertas.',
            endVisit: 'Finalizar visita',
            header: 'Has salido exitosamente',
            viewWorkOrders: 'Registrar otra orden de trabajo',
          },
          verification: {
            code: {
              description:
                'Para salir, por favor obtén el código de 4 dígitos del encargado del sitio o contacto designado.',
              continue: 'Continuar',
            },
            geo: {
              checkOut: 'Salir',
              continue: 'Continuar',
            },
          },
        },
        detail: {
          assets: 'Activos',
          call: 'Llamar',
          checkOut: 'Salir',
          closed: 'Cerrado',
          details: 'Detalles',
          dueBy: 'Fecha de vencimiento',
          manageEngineers: 'Gestionar ingenieros',
          notAvailable: 'No disponible',
          pointOfContact: 'Persona de contacto',
          siteAccessTimes: 'Horarios de acceso al sitio',
          siteAccessInstructions: 'Instrucciones de acceso',
          siteAddress: 'Dirección del sitio',
          siteNotes: 'Notas del sitio',
          siteTelephone: 'Teléfono del sitio',
          siteLocation: 'Ubicación del sitio',
          updates: 'Actualizaciones',
          more: 'Más',
          mismatchErrorTitle: 'Error de orden de trabajo',
          mismatchErrorMessage:
            'La orden de trabajo a la que intentas acceder no coincide con la que tienes registrada. Por favor, revisa tu orden y vuelve a intentarlo.',
          siteDocuments: 'Documentos del sitio',
          validFrom: 'Válido desde',
          validUntil: 'Válido hasta',
          documentName: 'Nombre del documento',
          documentType: 'Tipo de documento',
          attachments: 'Archivos de la orden de trabajo',
          download: 'Descargar',
          workDetails: 'Detalles del trabajo',
        },
        engineers: {
          assistants: {
            addAssistantEngineer: 'Agregar ingeniero asistente',
            assistantEngineers: 'Ingenieros asistentes',
            description:
              'Por razones de seguridad, por favor especifica los nombres de cada ingeniero en el sitio.',
            editMainEngineer: 'Editar ingeniero principal',
            errors: {
              creatingEngineer: 'Error al crear ingeniero',
              creatingSession: 'Error al crear sesión',
            },
            header: 'Ingenieros en el sitio',
            mainEngineer: 'Ingeniero principal',
            newAssistantEngineer: 'Ingresa su nombre completo',
            next: 'Siguiente',
            removeEngineer: 'Eliminar ingeniero',
            selectExistingAssistantEngineer: 'Comienza a escribir su nombre',
          },
          index: {
            description:
              'Por razones de seguridad, por favor especifica los nombres de cada ingeniero en el sitio.',
            errorCreatingEngineer: 'Error al crear ingeniero, por favor intenta de nuevo.',
            header: 'Ingenieros en el sitio',
            hintMainEngineer: 'Ingresa el nombre completo del ingeniero principal',
            newMainEngineer: 'Nuevo ingeniero principal',
            next: 'Siguiente',
            selectExistingMainEngineer: 'Selecciona un ingeniero principal existente',
            yes: 'Sí',
            no: 'No',
            mainEngineerLabel: '¿Eres el ingeniero principal?',
          },
        },
        index: {
          callUsOn: 'Llámanos al {phoneNumber}',
          description: '¿No encuentras lo que buscas?',
          dueBy: 'Fecha de vencimiento',
          header: 'Seleccionar orden de trabajo',
          notAvailable: 'No disponible',
          searchWorkOrders: 'Buscar órdenes de trabajo...',
        },
        manageEngineers: {
          manageEngineers: 'Gestionar ingenieros',
          notWorking: 'Trabajadores inactivos',
          pause: 'Pausar',
          resume: 'Reanudar',
          workingNow: 'Trabajadores activos',
          startTime: 'Hora de inicio',
          endTime: 'Hora de fin',
          duration: 'Duración',
        },
        startWorkChecks: {
          feedback: {
            feedbackTitle: 'Retroalimentación',
            feedbackDescription:
              'Por favor, proporciona comentarios sobre la orden de trabajo para ayudarnos a mejorar nuestros servicios.',
            feedbackLabel: 'Comentarios',
            filesLabel: 'Adjuntos',
            submissionLabel: 'Enviar comentarios',
          },
          hazards: {
            back: 'Regresar',
            hazards: 'Peligros',
            next: 'Siguiente',
            no: 'No',
            noTasksForHazard: 'No hay tareas para este peligro.',
            yes: 'Sí',
          },
          induction: {
            continue: 'Continuar',
            induction: 'Inducción',
          },
          index: {
            checkIn: 'Registrar entrada',
            description:
              'Por favor, completa la siguiente evaluación de riesgos para el trabajo seleccionado.',
            fail: 'Error al procesar las verificaciones de inicio de trabajo.',
            haltMessage:
              'Riesgos potenciales detectados. Por favor, detén el trabajo, revisa las pautas de seguridad y contacta a tu supervisor para más instrucciones.',
            header: 'Verificaciones de inicio de trabajo',
            endVisit: 'Finalizar visita',
            leaveFeedback: 'Dejar comentarios',
          },
          safeToProceed: {
            continue: 'Continuar',
            safeToProceed: 'Seguro para proceder',
          },
        },
      },
    },
    index: {
      title: 'Bienvenido',
      description: 'Escanea el código QR en tu ubicación para comenzar.',
    },
    login: {
      errorTitle: 'Error inesperado',
      errorMessage:
        'Ocurrió un error inesperado. Por favor, intenta escanear el código QR nuevamente.',
    },
    unauthenticated: {
      welcome: {
        title: 'Bienvenido a {site}',
        description:
          'Antes de mostrarte cualquier orden de trabajo, necesitamos verificar tus datos. Haz clic en el botón de abajo para continuar.',
        next: 'Continuar',
      },
      index: {
        errorTitle: 'Error inesperado',
        errorMessage:
          'Ocurrió un error inesperado. Por favor, intenta escanear el código QR nuevamente.',
      },
      contractor: {
        title: '¿Para quién trabajas?',
        contractor: 'Contratista',
        contractorLabel: 'Comienza a escribir el nombre de tu empresa',
        contractorHint: 'Debes ingresar 3 caracteres o más para ver resultados',
        defaultSelectPlaceholder: '--Por favor selecciona--',
        next: 'Siguiente',
      },
      user: {
        title: '¿Quién eres?',
        cancel: 'Cancelar',
        createNewUserLabel: 'Mi nombre no está en la lista',
        existingUserLabel: 'Comienza a escribir tu nombre',
        existingUserHint: 'Debes ingresar 3 caracteres o más para ver resultados',
        newUserLabel: 'Ingresa tu nombre completo',
        next: 'Siguiente',
        user: 'Usuario',
      },
      verification: {
        methods: {
          add: {
            add: 'Agregar método de verificación',
            defaultSelectPlaceholder: '--Por favor selecciona--',
            emailLabel: 'Correo electrónico',
            existingMethodWarning:
              'Ya tienes una solicitud pendiente para este método de verificación esperando aprobación del administrador. Agregar uno nuevo lo sobrescribirá.',
            method: 'Método',
            methodLabel: 'Método',
            mobileCountryHint: 'Por favor selecciona tu código de país',
            mobileCountryLabel: 'Código de país móvil',
            mobileHint: 'Por favor ingresa tu número móvil',
            mobileLabel: 'Móvil',
            title: 'Agregar método de verificación',
          },
          confirm: {
            confirm: 'Confirmar',
            description: 'Por favor confirma tu método de verificación para continuar.',
            label: 'Introduce tu código',
            resend: 'Reenviar',
            resendPrompt: '¿No recibiste un código?',
            title: 'Confirmar método de verificación',
          },
          confirmed: {
            description:
              'Se te notificará una vez que este método de verificación haya sido aprobado por tu administrador, y entonces podrás usarlo para verificar tu identidad.',
            forceApproval: 'Hasta que sea aprobado, no puedes acceder a las órdenes de trabajo.',
            nonForceApproval:
              'Mientras tanto, puedes continuar accediendo a las órdenes de trabajo con acceso reducido.',
            nonForceApprovalButtonLabel: 'Continuar con acceso reducido',
            title: 'En espera de aprobación',
          },
          addNew: 'Agregar nuevo método de verificación',
          description:
            'Necesitamos verificar tu identidad para darte acceso completo a la orden de trabajo.',
          email: 'Correo electrónico',
          hint: 'Enviaremos un enlace a tu método de verificación seleccionado que te dará acceso completo a la orden de trabajo. Si necesitas cambiar algún método existente, por favor contacta a tu administrador.',
          label: 'Selecciona un método de verificación',
          next: 'Siguiente',
          pendingHint: 'Esperando aprobación de tu administrador',
          sms: 'SMS',
          title: 'Verificación',
        },
        optional: {
          hint: 'Verificar tus datos te dará acceso completo a la orden de trabajo',
          label: '¿Quieres verificar tus datos?',
          next: 'Siguiente',
          no: 'No',
          noHint:
            'No quiero verificar mis datos y continuar con acceso reducido a la orden de trabajo',
          title: 'Verificación',
          yes: 'Sí',
          yesHint: 'Quiero verificar mis datos y obtener acceso completo a la orden de trabajo',
        },
        sent: {
          description:
            'Se ha enviado un enlace de inicio de sesión a {identifier}. Por favor haz clic en el enlace para completar tu inicio de sesión.',
          title: 'Enlace de inicio de sesión enviado',
        },
      },
    },
  },
  utils: {
    getActivityLog: {
      yesterday: 'Ayer',
      today: 'Hoy',
      days: {
        monday: 'Lunes',
        tuesday: 'Martes',
        wednesday: 'Miércoles',
        thursday: 'Jueves',
        friday: 'Viernes',
        saturday: 'Sábado',
        sunday: 'Domingo',
      },
      months: {
        january: 'Enero',
        february: 'Febrero',
        march: 'Marzo',
        april: 'Abril',
        may: 'Mayo',
        june: 'Junio',
        july: 'Julio',
        august: 'Agosto',
        september: 'Septiembre',
        october: 'Octubre',
        november: 'Noviembre',
        december: 'Diciembre',
      },
    },
  },
  composables: {
    useRedirectToError: {
      title: 'Algo salió mal',
      message: 'Por favor, intenta escanear el código QR nuevamente.',
    },
    useResolveWorkOrderEvents: {
      user: {
        unknown: 'Usuario desconocido',
      },
      none: 'Ninguno',
      types: {
        stateTransition: 'Estado cambiado',
        contractorAssigned: 'Contratista asignado',
        engineerAssigned: 'Ingeniero asignado',
        serviceAssigned: 'Servicio asignado',
        priorityChanged: 'Prioridad cambiada',
        actionableDateChanged: 'Fecha de acción cambiada',
        dueDateChanged: 'Fecha de vencimiento cambiada',
        etaDateChanged: 'Fecha estimada de llegada cambiada',
        spendLimitApproved: 'Límite de gasto aprobado',
        spendLimitCancelled: 'Solicitud de límite de gasto cancelada',
        spendLimitRejected: 'Límite de gasto rechazado',
        spendLimitRequested: 'Límite de gasto solicitado',
        jobSheetUploaded: 'Hoja de trabajo subida',
        slaAlertSent: 'Alerta de SLA por tiempo de atención excedido',
        issuedWorkPermit: 'Permiso de trabajo emitido',
        requestForServiceSent: 'Solicitud de servicio enviada',
        comment: 'Comentario agregado',
        unknown: 'Evento desconocido',
      },
      labels: {
        actionableDate: 'Fecha de acción',
        comment: 'Comentario',
        file: 'Archivo',
        contractor: 'Contratista',
        dueDate: 'Fecha de vencimiento',
        etaDate: 'Fecha estimada de llegada',
        engineer: 'Ingeniero',
        priority: 'Prioridad',
        requestForService: 'Solicitud de servicio',
        service: 'Servicio',
        spendLimit: 'Límite de gasto',
        status: 'Estado',
        workPermit: 'Permiso de trabajo',
      },
    },
  },
}
